export const InviteErrorReasons = [
  'has_subscription',
  'already_family_member',
  'limit_reached',
  'country_mismatch',
  'unknown',
] as const;

export type InviteErrorReason = (typeof InviteErrorReasons)[number];
